import React from "react" ;
import {Route, Switch} from "react-router-dom";
import {
    PATH_MESSAGING_ROOT, PATH_HOME_ROOT
} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import MessagingTab from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingTab";
import MessagingAppBodyHeader from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingAppBodyHeader";

const MessagingAppBody= (props) =>
{
    return (
        <div className="dt-module__container">

            <MessagingAppBodyHeader/>

            <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>

                <div className="dt-module__content-inner">
                    <div className="dt-module__list">
                        <Switch>
                            <Route path={PATH_MESSAGING_ROOT} render={(thisprops) => <MessagingTab {...thisprops}/>}/>
                            <Route path={PATH_HOME_ROOT} render={(thisprops) => <MessagingTab {...thisprops}/>}/>
                        </Switch>
                    </div>
                </div>

                <ScrollRails />

            </div>
        </div>
    );
}

export default MessagingAppBody;
